import { jsx } from "react/jsx-runtime";
import MuiCheckbox from "@mui/material/Checkbox";
import invariant from "tiny-warning";
function fieldToCheckbox({
  disabled,
  field: { onBlur: fieldOnBlur, ...field },
  form: { isSubmitting },
  type,
  onBlur,
  ...props
}) {
  const indeterminate = !Array.isArray(field.value) && field.value == null;
  if (process.env.NODE_ENV !== "production") {
    invariant(
      type === "checkbox",
      `property type=checkbox is missing from field ${field.name}, this can caused unexpected behaviour`
    );
  }
  return {
    disabled: disabled ?? isSubmitting,
    indeterminate,
    onBlur: onBlur ?? function(e) {
      fieldOnBlur(e ?? field.name);
    },
    ...field,
    ...props
  };
}
function Checkbox(props) {
  return /* @__PURE__ */ jsx(MuiCheckbox, { ...fieldToCheckbox(props) });
}
Checkbox.displayName = "FormikMaterialUICheckbox";
export {
  Checkbox,
  fieldToCheckbox
};
//# sourceMappingURL=Checkbox.js.map
